<script setup lang="ts">
  import { computed } from 'vue'
  import { ContentRowTwoColumns, FlagIcon } from '@gat-ship/vue-components'
  import { IconLoading } from '@gat-ship/icons'
  import { usePortDetailContext } from '../composables/usePortDetail'

  const portDetail = usePortDetailContext()

  const port = computed(() => portDetail?.port.value)
</script>

<template>
  <div
    v-if="portDetail?.loadingPort.value"
    class="text-muted-foreground flex animate-pulse items-center justify-center gap-2 p-6 text-sm"
  >
    <IconLoading class="size-5" /> Loading port…
  </div>

  <template v-else-if="port">
    <ContentRowTwoColumns
      title="Identification"
      description="The port's location code and names."
    >
      <div class="flex flex-col gap-3">
        <div class="flex items-center gap-2">
          <FlagIcon
            :flag="port.locationCode.slice(0, 2)"
            class="size-5 shrink-0 rounded-sm"
          />
          <span class="font-medium">{{ port.name }}</span>
          <span class="text-muted-foreground text-sm">
            {{ port.locationCode }}
          </span>
        </div>
        <div v-if="port.nativeName" class="text-muted-foreground text-sm">
          {{ port.nativeName }}
        </div>
      </div>
    </ContentRowTwoColumns>

    <ContentRowTwoColumns
      title="Configuration"
      description="How this port is configured for your tenant."
    >
      <div class="flex flex-col gap-2 text-sm">
        <div class="flex items-baseline gap-2">
          <span class="text-muted-foreground w-40 shrink-0">Time zone</span>
          <span>{{ port.timeZone ?? 'Not configured' }}</span>
        </div>
        <div class="flex items-baseline gap-2">
          <span class="text-muted-foreground w-40 shrink-0">
            ETA at pilot station
          </span>
          <span>{{ port.useEtaAtPilotStation ? 'Enabled' : 'Disabled' }}</span>
        </div>
      </div>
    </ContentRowTwoColumns>
  </template>

  <div
    v-else
    class="text-muted-foreground flex flex-1 items-center justify-center p-8 text-center text-sm"
  >
    Port not found.
  </div>
</template>
